module.exports = __webpack_public_path__ + "media/images/banner-ae9eb287dd6178a57e6dca35b54cd71a.png";